const backToTop = document.querySelector('#back-to-top');

let overlayStatus = 0;

function goToSection(section) {
  if (section === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    document.getElementById(section).scrollIntoView({ behavior: 'smooth' });
  }
}

const nav = document.querySelector('nav');
const navLinks = document.querySelectorAll('nav a');
const sections = document.querySelectorAll('section');

let sectionsPositions = [];

// FUNCTIONS

function checkNavigation() {
  if (window.pageYOffset > 100 && overlayStatus != 1) {
    nav.classList.add('bg');
    backToTop.style.opacity = "1";
    backToTop.style.visibility = "visible";
  } else {
    nav.classList.remove('bg');
    backToTop.style.opacity = "0";
    backToTop.style.visibility = "hidden";
  }
  setTimeout(checkSections, 500);
}

function checkPosition() {
  sectionsPositions = [];
  for (let i = 0; i < sections.length; i++) {
    sectionsPositions.push([
      sections[i].offsetTop,
      sections[i].offsetTop + sections[i].offsetHeight
    ]);
  }
}

function checkSections() {
  const pageY = window.pageYOffset;
  const pageHeight = document.body.offsetHeight;
  const pageBottom = window.innerHeight + Math.round(window.scrollY);
  removeNavClass();
  if (pageY >= sectionsPositions[3][0] - 250 || pageBottom >= pageHeight - 150) { // Contact
    navLinks[3].classList.add('active');
  } else if (pageY >= sectionsPositions[2][0] - 350) { // Reels
    navLinks[2].classList.add('active');
  } else if (pageY >= sectionsPositions[1][0] - 350) { // Credits
    navLinks[1].classList.add('active');
  } else if (pageY >= sectionsPositions[0][0] - 350) { // About
    navLinks[0].classList.add('active');
  }
}

function removeNavClass() {
  for (let i = 0; i < navLinks.length; i++) {
    navLinks[i].classList.remove('active');
  }
}

navLinks.forEach(element => {
  element.addEventListener("click", function (event) {
    event.preventDefault()
    goToSection(element.getAttribute("href").slice(1))
  });
});

backToTop.addEventListener("click", function (event) {
  event.preventDefault();
  goToSection("home");
});

window.onscroll = function () { checkNavigation() }
window.onresize = function (event) { checkPosition() }

checkPosition();
checkNavigation();

const creditsFull = document.querySelector('#credits-full');
const creditsFullOpen = document.querySelector('#credits-open');
const creditsFullClose = document.querySelector('#credits-close');
const isFirefox = navigator.userAgent.includes("Firefox");

creditsFullOpen.addEventListener("click", function (event) {
  event.preventDefault();
  overlayStatus = 1;
  goToSection("credits");
  if (isFirefox) {
    setTimeout(() => { document.body.style.overflowY = "hidden"; }, 600);
  } else {
    document.body.style.overflowY = "hidden";
  }
  backToTop.style.opacity = "0";
  backToTop.style.visibility = "hidden";
  creditsFull.style.display = "block";
});

creditsFullClose.addEventListener("click", function (event) {
  event.preventDefault();
  overlayStatus = 0;
  document.body.style.overflowY = "scroll";
  backToTop.style.opacity = "1";
  backToTop.style.visibility = "visible";
  creditsFull.style.display = "none";
});

const formName = document.querySelector('input[name="name"]');
const formEmail = document.querySelector('input[name="email"]');
const formPhone = document.querySelector('input[name="phone"]');
const formMessage = document.querySelector('textarea[name="message"]');

const formSubmitBtn = document.querySelector('button[type="submit"]');
const formMessageCounter = document.querySelector('#form-message-counter');
const formMessageChars = document.querySelector('#form-message-chars');
const formSuccess = document.querySelector('#form-message-success');
const formError = document.querySelector('#form-message-error');
const formErrors = document.querySelector('#form-errors');

const formTimer = 10; // in seconds
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

let formEnabled;
let formNameVal = '',
    formEmailVal = '',
    formMessageVal = '';

// FUNCTIONS

function disableForm(error)
{
  formSubmitBtn.style.display = 'none';
  formMessageCounter.style.display = 'none';

  formName.value = '';
  formEmail.value = '';
  formMessage.value = '';
  
  formName.disabled = true;
  formEmail.disabled = true;
  formMessage.disabled = true;

  formName.style.opacity = .25;
  formEmail.style.opacity = .25;
  formMessage.style.opacity = .25;

  if (error) {
    formError.style.display = 'block'
  } else {
    formSuccess.style.display = 'block'
  }

  // countdown timer
  let timeLeft = formTimer;

  const countdownText = document.querySelectorAll(".countdown");
  countdownText.forEach((countdown) => {
    countdown.innerHTML = timeLeft;
  });
  
  const countdown = setInterval(function() {
    timeLeft -= 1;
    countdownText.forEach((countdown) => {
      countdown.innerHTML = timeLeft;
    });
    if (timeLeft <= 0) {
      clearInterval(countdown);
      resetForm();
    }
  }, 1000);
}

function manageErrors(errorName, errorEmail, errorMessage)
{
  formErrors.innerHTML = '';

  if (errorName) {
    formName.style.background = '#1A0000';
    formErrors.innerHTML += errorName + '<br>'
  } else {
    formName.style.background = 'black';
  }

  if (errorEmail) {
    formEmail.style.background = '#1A0000';
    formErrors.innerHTML += errorEmail + '<br>'
  } else {
    formEmail.style.background = 'black' ;
  }

  if (errorMessage) {
    formMessage.style.background = '#1A0000';
    formErrors.innerHTML += errorMessage
  } else {
    formMessage.style.background = 'black';
  }
}

function resetForm()
{
  formName.disabled = false;
  formEmail.disabled = false;
  formMessage.disabled = false;

  formName.style.opacity = 1;
  formEmail.style.opacity = 1;
  formMessage.style.opacity = 1;

  formError.style.display = 'none';
  formSuccess.style.display = 'none';
  formSubmitBtn.style.display = 'block';

  formMessageChars.innerHTML = '0';
  formMessageCounter.style.display = 'block';
}

function validateForm()
{
  formEnabled = true;
  let errorName = '',
      errorEmail = '',
      errorMessage = '';
  formNameVal = formName.value.trim();
  formEmailVal = formEmail.value.trim();
  formMessageVal = formMessage.value.trim();

  formMessageChars.innerHTML = formMessageVal.length;

  // check if not empty
  if (formNameVal.length === 0) {
    formEnabled = false;
    errorName = "Name is required";
  }
  if (formEmailVal.length === 0) {
    formEnabled = false;
    errorEmail = "Email is required";
  }
  if (formMessageVal.length === 0) {
    formEnabled = false;
    errorMessage = "Message is required";
  }
  
  // check length
  if (!errorName) {
    if (formNameVal.length < 2 || formNameVal.length > 50) {
      formEnabled = false;
      errorName = "Name should be at least 2 characters long";
    }
  }
  if (!errorEmail) {
    if (formEmailVal.length < 6 || formEmailVal.length > 50) {
      formEnabled = false;
      errorEmail = "Email should be at least 6 characters long";
    }
  }
  if (!errorMessage) {
    if (formMessageVal.length < 10 || formMessageVal.length > 2000) {
      formEnabled = false;
      errorMessage = "Message should be at least 10 characters long";
    }
  }

  // check email format
  if (!errorEmail) {
    if (!emailRegex.test(formEmailVal)) {
      formEnabled = false;
      errorEmail = "Email has incorrect format (user@domain)";
    }
  }
  
  // manage errors
  manageErrors(errorName, errorEmail, errorMessage);
  
  // if validated
  if (formEnabled && formPhone.value === '') {
    formSubmitBtn.disabled = false;
  } else {
    formSubmitBtn.disabled = true;
  }
}

formSubmitBtn.addEventListener("click", function (event) {
  event.preventDefault();
  grecaptcha.ready(function () {
    grecaptcha.execute('6LdI1WIpAAAAAIdDo6K3-vGWH1Ryr7E2IuFkZ9yf', { action: 'submit' }).then(function (token) {
      formSubmitBtn.disabled = true;
      const data = {
        name: formNameVal,
        email: formEmailVal,
        message: formMessageVal
      };
      fetch('/', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (error) {
        disableForm((error === 'error') ? true : false);
      });
    });
  });
});

[formName, formEmail, formMessage].forEach(item => {
  item.addEventListener('keyup', () => {
    validateForm();
  });
});
